import { DescriptionOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';
import { getMenuLabel } from '../../global/auth/use-menu-labels/use-menu-labels';

const route = 'management';

export const getManagerRoutesMap = ({ userIdentityService, org }: GetRoutesConfig): RoutesMaps => {
  const { isActivityLeader, isProgramManager, isVmAdmin } = userIdentityService;
  // Default to true if org data is not available yet
  const packageConfig = org?.packageConfig;
  const menuLabels = org?.menuLabels;

  return {
    route,
    heading: 'Management',
    Icon: DescriptionOutlined,
    isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
    items: [
      {
        ...getMenuLabel('managementDashboard', menuLabels),
        route: 'dashboard',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.insights : false
      },
      {
        ...getMenuLabel('managementActivityManagement', menuLabels),
        route: 'activity-management',
        isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        ...getMenuLabel('managementRosters', menuLabels),
        route: 'rosters',
        isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        ...getMenuLabel('managementVolunteers', menuLabels),
        route: 'volunteers',
        isAuthorized: isProgramManager || isVmAdmin,
      },
      {
        ...getMenuLabel('managementBulletins', menuLabels),
        route: 'bulletins',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.bulletins : false
      },
      {
        ...getMenuLabel('managementReportManagement', menuLabels),
        route: 'report-management',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        ...getMenuLabel('managementIncidentManagement', menuLabels),
        route: 'incident-management',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.incidents : false
      },
      {
        label: 'Program Management',
        route: 'program-management',
        isAuthorized: isProgramManager,
      },
    ],
  };
};
